import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'qm-person-role-icon',
  templateUrl: './person-role-icon.component.html',
  styleUrls: ['./person-role-icon.component.scss']
})
export class PersonRoleIconComponent {

  @Input()
  public number = 0;
}
